import React, { Component } from "react";
import { RefreshCcw } from "react-feather";
import FileBase64 from "react-file-base64";
import { FilesFilter } from "../helper/FileFormatHelper";
import shareto from "views/job-details/img/upload.png";
import RelievingLetter from "views/profile/img/documents/RelievingLetter.png";
import {
  getDocsAction,
  uploadDocumentsAction,
  ViewDocumentAction,
} from "store/Profile";
import { connect } from "react-redux";
import { Modal } from "react-responsive-modal";
class Education extends Component {
  constructor(props) {
    super(props);
    this.fileUploader = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      docID: "",
      open: false,
      currentDocumentNameBase64: "",
      CurrentDocumentBase64: "",
      ext: "",
      files: [],
      disabledPan: false,
      declaration: {
        AppliedPanNo: 0,
        password: "",
        startDate: new Date(),
      },
    };
  }
  componentDidMount() {
    // this.props.getDocs(this.props.Auth.HCID);
  }
  async getAllDocumentOfUser(canID) {
    let self = this;

    // let response = await this.props.getDocs(canID);
  }
  onOpenModal = () => {
    var self = this;
    self.setState({ open: true });
  };
  onCloseModal = () => {
    var self = this;
    self.setState({ open: false });
  };
  handleClick(e) {
    this.setState({ docID: e.target.value });
  }
  async getFiles(files) {
    // console.log('docID, files', docID, files)
    if (this.state.docID) {
      let check = await FilesFilter(files);
      if (check) {
        await this.setState({ files: files });
        this.uploadDocument(files, this.state.docID);
      } else {
        alert(
          "Please check your file format, only images doc and pdf are allowed"
        );
      }
    } else {
      alert("Please select any one document");
    }
  }
  uploadDocument(files, docID) {
    // console.log('docID', docID)
    // console.log('files', files)
    var self = this;
    var TmpArray = {
      DocumentID: docID,
      FileName: files.name,
      FileData: files.base64,
      CandidateNo: this.props.Auth.HCID,
      UserID: 0,
      Notes: "By Career through DocumentPOrtal",
    };
    try {
      let response = this.props.uploadDocuments(TmpArray);
      if (response) {
        alert("Document Uploaded");
        // console.log(Data);
        this.props.getDocs(this.props.Auth.HCID);
        this.forceUpdate();
      }
    } catch (e) {
      alert("something went wrong");
      console.log(e);
    }
  }
  async openDocumentView(docID) {
  

    let self = this;
    // var DocArray = this.props.document.filter(
    //   (item) => item.DocumentID == docID
    // );
    //-----------------------------------------------------------------------------------
    let response = await this.props.ViewDocument(docID);
    // .then(async function ({ Data }) {

    if (response) {
      // console.log(data);
      var myarr = response.Data.FileData.split(":");
      var datapdf = "data:application/pdf;base64,";
      var dataimage = "data:image/jpeg;base64,";
      let finalbase64 = response.Data.FileData;
      let ext = response.Data.FileName.split(".").pop().toLowerCase();
      if (myarr[0] != "data") {
        if (
          ext == "pdf" ||
          ext == "PDF" ||
          ext == "docx" ||
          ext == "doc" ||
          ext == "msg" ||
          ext == "xls" ||
          ext == "xlsx" ||
          ext == "tif"
        ) {
          finalbase64 = datapdf + finalbase64;
        } else {
          finalbase64 = dataimage + finalbase64;
        }
      }
      self.setState({
        CurrentDocumentBase64: finalbase64,
        currentDocumentNameBase64: response.Data.FileName,
        ext: ext,
      });

      self.onOpenModal();
      // await store.dispatch(UserDocumentStore(data.Data));
    }
    // });
  }
  render() {
    var addressProof = this.props.Documents
      ? this.props.Documents.Data.filter((item) => item.DocumentID == 6)
      : [];
    return (
      <>
        <card className="rounded-12px drop-shadow20 bg-white block sm-shadow-none lg:p-8 md:p-8 p-5 mt-2">
          <div className="lg:px-12 md:px-12 pb-8">
            <div className="flex justify-center">
              <div className="lg:w-4/5 md:w-4/5  text-center">
                <p className="text898989 fsize14 ">
                  Drag - Drop or Upload any one of the following
                </p>
                <div className="flex items-center justify-evenly py-6 flex-wrap">
                  <div className="lg:ml-8 md:ml-8 lg:mb-0 md:mb-0 mb-4">
                    <input
                      id="AddressProof"
                      class="radio-custom"
                      name="radio-group2"
                      type="radio"
                      value="6"
                      onClick={(e) => this.handleClick(e)}
                    />
                    <label
                      for="AddressProof"
                      class="radio-custom-label fsize16 text-black font-normal"
                    >
                      Address Proof
                    </label>
                  </div>
                  <div className="lg:ml-8 md:ml-8 lg:mb-0 md:mb-0 mb-4">
                    <input
                      id="Backside"
                      class="radio-custom"
                      name="radio-group2"
                      type="radio"
                      value="6"
                      onClick={(e) => this.handleClick(e)}
                    />
                    <label
                      for="Backside"
                      class="radio-custom-label fsize16 text-black font-normal"
                    >
                      Back side if applicable
                    </label>
                  </div>
                </div>

                <div className="lg:my-4 md:my-4">
                  <div class="form-group  relative cursor-pointer m-auto sm-w-full w-430px h-230px justify-center resume-upload items-center flex   ">
                    <div className="flex justify-center items-center cursor-pointer w-full h-full">
                      <div className="filbase-uploader">
                        <img
                          src={shareto}
                          className="m-auto resume-share-w"
                          alt="shareto"
                        />
                        <div>
                          <FileBase64
                            multiple={false}
                            onDone={this.getFiles.bind(this)}
                          />
                        </div>
                        <p className="fsize16 text1B1B1B pt-6">
                          Drag and drop{" "}
                          <span className="textE77817 cursor-pointer underline font-semibold">
                            Browse
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="divider-d8d8d8 my-8"></div>

            <div className="lg:grid md:grid lg:grid-cols-4 md:grid-cols-4 gap-10">
              {/* post graduation */}
              {this.props.Documents &&
                addressProof.map((Document) => (
                  <card
                    className="rounded-sm borderblue-t-5px h-190px drop-shadow20 bg-white block px-6 py-4 lg:mb-0 lg:mb-0 mb-6 "
                    onClick={() => this.openDocumentView(Document.UniqueDocID)}
                  >
                    <div className="flex justify-center py-1">
                      <img
                        src={
                          "https://clg.icicibank.com/career/RecruiterContent/assets/img/defaultdocImage.png"
                        }
                        alt="passport"
                        className="w-50px h-50px cursor-pointer"
                      />
                    </div>
                    <p className="border707070-t opacity-20 my-4 	"></p>
                    <div className="flex justify-between">
                      <h2 className="fsize16 text-black font-bold truncate w-170px">
                        {Document.DocumentTitle}
                      </h2>
                      <RefreshCcw className="text053C6D w-5 h-5" />
                    </div>

                    <div className="flex justify-start items-center mt-2">
                      <div className="flex items-center mr-2">
                        <p className="fsize14 text4B4B4B opacity-90">
                          {`${Document.Notes}`.split(" ")[0].split("(")[1]}
                        </p>
                      </div>
                      <div className="flex items-center">
                        <span className="dot-point bg-bluecolor rounded-full mx-2"></span>
                        <p className="fsize14 text4B4B4B opacity-70">
                          {Document.DocumentType}
                        </p>
                      </div>
                    </div>
                  </card>
                ))}
            </div>
          </div>
        </card>
        <div className="popup__modal">
          <Modal
            open={this.state.open}
            onClose={this.onCloseModal}
            center
            classNames={{
              modal: "documents-view-w",
            }}
          >
            <h2 className="p-4 text-white fsize16 bg-E77817">
              {this.state.currentDocumentNameBase64}
            </h2>
            {this.state.ext == "pdf" ? (
              <iframe
                src={this.state.CurrentDocumentBase64}
                width="540"
                height="450"
              ></iframe>
            ) : this.state.ext == "doc" ||
              this.state.ext == "xlsx" ||
              this.state.ext == "docx" ||
              this.state.ext == "xls" ||
              this.state.ext == "tif" ||
              this.state.ext == "eml" ||
              this.state.ext == "msg" ? (
              <div className="row no-margin scrollable pdfDoc ">
                <img
                  className="img-responsive upload_img popup__modal"
                  src={require("assets/img/download.png")}
                />

                <a
                  className="cent_bttn"
                  href={this.state.CurrentDocumentBase64}
                  title="Download Resume"
                  download={this.state.currentDocumentNameBase64}
                >
                  <button
                    className="btn btn1 font-bold"
                    style={{ backgroundColor: "#FFB740" }}
                    id="cc_resume"
                  >
                    Get File
                  </button>
                </a>
              </div>
            ) : (
              <div className="p-4">
                {" "}
                <img
                  className="img-responsive rounded-lg w-full h-docs-400px"
                  src={this.state.CurrentDocumentBase64}
                />
              </div>
            )}
          </Modal>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Documents: state.Profile.home.DOCUMENTS,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getDocs: async (payload) => await dispatch(getDocsAction(payload)),
    uploadDocuments: async (payload) =>
      await dispatch(uploadDocumentsAction(payload)),
    ViewDocument: async (payload) =>
      await dispatch(ViewDocumentAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Education);
// export default Education;
